import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Subject, takeUntil} from 'rxjs';
import {iResponseList} from '../../../models/response/response.model';
import {DoctorModel} from '../../../models/doctor/doctor.model';
import {DoctorService} from '../../../services/doctor/doctor.service';
import {MatCheckbox} from '@angular/material/checkbox';
import {PatientFile} from '../../../models/patient-file/patient-file.model';
import {UploadService} from '../../../services/upload/upload.service';

@Component({
    selector: 'app-file-permission-modal',
    imports: [
        MatCheckbox
    ],
    templateUrl: './file-permission-modal.component.html',
    styleUrl: './file-permission-modal.component.sass'
})
export class FilePermissionModalComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();
    doctorList: DoctorModel[] = [];
    patientFile!: PatientFile;
    shownName!: string;

    constructor(
        public dialogRef: MatDialogRef<FilePermissionModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { file: PatientFile, fileName: string },
        private doctorService: DoctorService,
        private uploadService: UploadService
    ) {
    }

    ngOnInit(): void {
        if (this.data.file) {
            this.patientFile = this.data.file;
        }
        if (this.data.fileName) {
            this.shownName = this.data.fileName
        }
        this.getDoctors();
    }

    ngOnDestroy(): void {
    }

    onClose(): void {
        this.dialogRef.close();
    }

    updateDoctorList(checked: boolean, doctor: DoctorModel): void {
        if (checked) {
            this.grantPermissions(this.patientFile.id, doctor.id);
        } else {
            this.removePermissions(this.patientFile.id, doctor.permissionId!);
        }

    }

    onSubmit(): void {
        this.dialogRef.close();
    }

    private getDoctors(): void {
        this.doctorService.getDoctors()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: iResponseList<DoctorModel>) => {
                    this.doctorList = response.data;
                    this.setPermissionsForDoctors();
                },
                error: (error) => {
                    console.error(error)
                }
            })
    }

    private setPermissionsForDoctors(): void {
        this.doctorList.forEach(doctor => {
            this.patientFile.permissionsGranted.forEach(permission => {
                if (permission.doctor.id === doctor.id) {
                    doctor.checked = true;
                    doctor.permissionId = permission.id
                }
            })
        })
    }

    private grantPermissions(fileId: string, doctorId: string): void {
        this.uploadService.setFilePermissions(fileId, doctorId)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: any) => {
                },
                error: (error) => {
                    console.error(error)
                }
            })
    }

    private removePermissions(fileId: string, permissionId: string): void {
        this.uploadService.deleteFilePermissions(fileId, permissionId)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: any) => {
                },
                error: (error) => {
                    console.error(error)
                }
            })
    }
}
